import { ofType } from 'redux-observable';
import { debounceTime, switchMap, map, catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { REQUEST_MESSAGEABLE_NAMES, EPIC_ERROR } from 'Constants/redux';
import service from 'Api/service';
import { receiveMessageableNames } from 'Actions';

const fetchMessageableNamesEpic = (action$) =>
  action$.pipe(
    ofType(REQUEST_MESSAGEABLE_NAMES),
    debounceTime(500),
    switchMap(() =>
      from(
        service.get(
          `${
            import.meta.env.VITE_API_DOMAIN
          }/api/customer_location_relationships/messageable_names`
        )
      ).pipe(
        map((response) => receiveMessageableNames(response.data.names)),
        catchError((error) => {
          console.error('fetchMessageableNamesEpic error', error);
          return of({ type: EPIC_ERROR });
        })
      )
    )
  );

export default fetchMessageableNamesEpic;
